<template>
  <div class="location-edit-form-wrapper card">
    <page-header
      title="Edit Location"
      breadcrumbText="Dashboard >> Settings >> Account Owner >> Edit Information"
    />
    <div class="edit-location-form">
      <div class="container-fluid">
        <div class="row">
          <div class="pl-0 col-md-4 col-lg-4 col-12">
            <div class="picture-upload-form text-center">
              <div class="picture-upload-form__header">
                <p class="text-secondary-orange font-semibold">
                  Upload Picture
                </p>
              </div>
              <div class="my-3">
                <image-upload
                  @input="handleImageUpload($event)"
                  @remove-image="removeImage"
                  :isUploadingImage="isUploadingImage"
                />
              </div>
            </div>
          </div>

          <div class="col-md-8 col-lg-8 col-12">
            <div class="edit-location-form__col-two__header">
              <p class="text-secondary-orange font-semibold mb-3">
                Location Details
              </p>
            </div>
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12 col-lg-6 col-12">
                  <div class="edit-location-form__single-input-wrapper">
                    <label class="label">Location Name</label>
                    <input
                      type="text"
                      class="input"
                      v-model="location.locationName"
                    />
                  </div>
                </div>
                <div class="col-md-12 col-lg-6 col-12">
                  <div class="edit-location-form__single-input-wrapper">
                    <label class="label">Address</label>
                    <input
                      type="text"
                      class="input"
                      v-model="location.address"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 col-lg-6 col-12">
                  <div class="edit-location-form__single-input-wrapper">
                    <label class="label">Location Type</label>
                    <input type="text" class="input" v-model="location.type" />
                  </div>
                </div>
                <div class="col-md-12 col-lg-6 col-12">
                  <div class="edit-location-form__single-input-wrapper">
                    <label class="label">Country</label>
                    <input
                      type="text"
                      class="input"
                      v-model="location.country"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 col-lg-6 col-12">
                  <div class="edit-location-form__single-input-wrapper">
                    <label class="label">State</label>
                    <el-select
                      filterable
                      v-model="location.state"
                      placeholder="Select"
                    >
                      <el-option
                        v-for="state in states"
                        :key="state.id"
                        :label="state.name"
                        :value="state.stateId"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="col-md-12 col-lg-6 col-12">
                  <div class="edit-location-form__single-input-wrapper">
                    <label class="label">City</label>
                    <input type="text" class="input" v-model="location.city" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 col-lg-6 col-12">
                  <div class="edit-location-form__single-input-wrapper">
                    <label class="label">ZIP Code</label>
                    <input
                      type="text"
                      class="input"
                      v-model="location.zipCode"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="button-wrapper">
      <button
        class="button button-secondary button-long"
        @click="$router.push({ name: 'LocationAndTax' })"
      >
        Cancel
      </button>
      <button class="button button-primary button-long" @click="updateLocation">
        <button-loader v-if="updatingLocation" /> <span v-else>Save</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      location: {},
      updatingLocation: false,
      states: [],
      locationid: "",
      isUploadingImage: false,
    };
  },
  mounted() {
    this.getLocationId();
    this.getAllStates();
  },
  methods: {
    async getLocationDetails(locationId) {
      try {
        let response = await this.$_getSingleLocationDetails(locationId);
        console.log(response);
        this.location = response.data.location;
      } catch (error) {
        this.handleError(error);
      }
    },
    async getAllStates() {
      try {
        let response = await this.$_getAllStates();
        console.log(response);
        this.states = response.data.findState;
      } catch (error) {
        this.handleError(error);
      }
    },
    async updateLocation() {
      delete this.location.createdAt;
      delete this.location.updatedat;
      this.updatingLocation = true;
      this.location.locationId = this.locationId;
      try {
        await this.$_updateLocation(this.location);
        this.handleSuccessfulUpdate();
        this.updatingLocation = false;
      } catch (error) {
        this.handleError(error);
        this.updatingLocation = false;
      }
    },
    handleSuccessfulUpdate() {
      this.generateToast("Location Successfully updated!", "success");
      setTimeout(() => {
        this.$router.push({ name: "LocationAndTax" });
      }, 1000);
    },
    getLocationId() {
      let locationId = localStorage.getItem("locationId");
      this.locationId = locationId;
      if (locationId) {
        this.getLocationDetails(locationId);
      } else {
        this.$router.push({ name: "LocationAndTax" });
      }
    },
    async handleImageUpload(image) {
      this.isUploadingImage = true;
      try {
        let response = await this.uploadImage(image);
        this.location.imageurl = response;
  
        this.isUploadingImage = false;
      } catch (error) {
        this.handleError(error);
        this.isUploadingImage = false;
      }
    },
    removeImage() {
      this.location.imageurl = null;
    },
  },
};
</script>

<style scoped>
.edit-location-form {
  margin: 2rem 0 1rem;
}
.picture-upload-form {
  border: 1px solid #edf2ef;
  border-radius: 10px;
  padding: 1rem 1rem;
}
.picture-upload-form__img-wrapper {
  position: relative;
}
.location-img {
  width: 10rem;
  margin: 1rem auto;
}
.upload-img-icon {
  position: absolute;
  right: 3.5rem;
  bottom: 1rem;
}
.picture-upload-form__meta {
  padding-top: 1rem;
}
.edit-location-form__single-input-wrapper {
  margin-bottom: 1.25rem;
}
.label {
  font-size: 0.9rem;
}
.input-field {
  display: block;
  width: 100%;
  height: 2.75rem;
  margin-bottom: 0.5rem;
  background: #fafafd;
  border: 0.5px solid #c5d1e6;
  box-sizing: border-box;
  border-radius: 4px;
}
.edit-location-form__col-three {
  padding-top: 2.25rem;
}
</style>
